import { createContext, useEffect, useState } from "react";
import authChannel, { AUTH_CHANNEL_EVENTS } from "./authChannel";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({});
  const [persist, setPersist] = useState(
    JSON.parse(localStorage.getItem("persist")) || true
  );

  useEffect(() => {
    if (!authChannel) return;

    const handleMessage = (event) => {
      const data = event?.data;
      if (!data) return;
      if (data.type === AUTH_CHANNEL_EVENTS.AUTH_UPDATED && data.auth) {
        setAuth(data.auth);
      } else if (data.type === AUTH_CHANNEL_EVENTS.AUTH_CLEARED) {
        setAuth({});
      }
    };

    authChannel.addEventListener("message", handleMessage);
    return () => authChannel.removeEventListener("message", handleMessage);
  }, []);

  return (
    <AuthContext.Provider value={{ auth, setAuth, persist, setPersist }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
